import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';
import { selectUser } from '@/auth/stores/auth-slice';
import { useAppSelector } from '@/common/redux/store';
import { env } from '../constants/env';

export const CrispWeb = () => {
  const user = useAppSelector(selectUser);

  useEffect(() => {
    if (env.CRISP_WEBSITE_ID && user?.type !== 'ADMIN') {
      Crisp.configure(env.CRISP_WEBSITE_ID);
    }
  }, [user]);

  return null;
};
